import(/* webpackMode: "eager" */ "/opt/build/repo/app/horoscope/page.tsx");
